// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__si70D","col":"styles_col__3u7z2"};